/* eslint-disable */
/* global __webpack_public_path__, V5PHONECOM */
// https://webpack.js.org/configuration/output/#output-publicpath
globalThis.__webpack_public_path__ = typeof V5PHONECOM !== 'undefined' ? V5PHONECOM.asset_path + '/app/' : '/';
